/* Duskhaven "Pieces you looked at": Add to cart / Choose options on each card (2026-10-10, Todd).
 * assets/dh-recent.js draws the cards from /products/<handle>.js. This small add-on watches every <dh-recent> element and,
 * for each .dh-recent-card without a button, looks the product up (the browser has just fetched it) and appends the same
 * button the other product cards carry (snippets/dh-product-card.liquid):
 *   - one variant: a form[data-dh-card-atc] that assets/dh-card-atc.js submits without leaving the page
 *   - several variants: "Choose options", a plain link to the product page
 *   - nothing available: a disabled "Sold out"
 * It is a separate file because dh-recent.js is close to the size limit of a single API upload. */
(function () {
  'use strict';
  if (window.__dhRecentAtc) return;
  window.__dhRecentAtc = true;

  var cache = {};

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function product(handle) {
    if (!cache[handle]) {
      cache[handle] = fetch(root() + 'products/' + encodeURIComponent(handle) + '.js', {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin'
      }).then(function (response) { return response.ok ? response.json() : null; }).catch(function () { return null; });
    }
    return cache[handle];
  }

  function el(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text != null) node.textContent = text;
    return node;
  }

  function shortName(title) {
    var match = /^(.+?)\s[–—-]\s(.+)$/.exec(String(title || ''));
    if (match && match[1].trim().split(/\s+/).length <= 3) return match[1].trim();
    return String(title || '');
  }

  function build(p) {
    var wrap = el('div', 'dh-card-atc');
    var variants = p.variants || [];
    var open = variants.filter(function (v) { return v && v.available; })[0];
    if (!p.available || !open) {
      var sold = el('button', 'dh-card-atc__btn', 'Sold out');
      sold.type = 'button';
      sold.disabled = true;
      wrap.appendChild(sold);
    } else if (variants.length === 1) {
      var form = el('form', 'dh-card-atc__form');
      form.action = root() + 'cart/add';
      form.method = 'post';
      form.setAttribute('data-dh-card-atc', '');
      var id = document.createElement('input');
      id.type = 'hidden';
      id.name = 'id';
      id.value = String(open.id);
      var qty = document.createElement('input');
      qty.type = 'hidden';
      qty.name = 'quantity';
      qty.value = '1';
      var button = el('button', 'dh-card-atc__btn');
      button.type = 'submit';
      button.setAttribute('aria-label', 'Add to cart: ' + p.title);
      button.setAttribute('data-dh-atc-name', shortName(p.title));
      var label = el('span', null, 'Add to cart');
      label.setAttribute('data-dh-atc-label', '');
      button.appendChild(label);
      form.appendChild(id);
      form.appendChild(qty);
      form.appendChild(button);
      wrap.appendChild(form);
    } else {
      var options = el('a', 'dh-card-atc__btn dh-card-atc__btn--options', 'Choose options');
      options.href = p.url || (root() + 'products/' + p.handle);
      options.setAttribute('aria-label', 'Choose options: ' + p.title);
      wrap.appendChild(options);
    }
    return wrap;
  }

  function decorate(card) {
    if (card.__dhAtc || card.querySelector('.dh-card-atc')) return;
    var link = card.querySelector('a.dh-card-image');
    var match = link && /\/products\/([^/?#]+)/.exec(link.getAttribute('href') || '');
    var body = card.querySelector('.dh-card-body');
    if (!match || !body) return;
    card.__dhAtc = true;
    product(decodeURIComponent(match[1])).then(function (p) {
      if (!p || card.querySelector('.dh-card-atc')) return;
      body.appendChild(build(p));
    });
  }

  function scan(root_) {
    (root_ || document).querySelectorAll('.dh-recent-card').forEach(decorate);
  }

  function watch() {
    document.querySelectorAll('dh-recent').forEach(function (host) {
      if (host.__dhAtcWatch) return;
      host.__dhAtcWatch = true;
      new MutationObserver(function () { scan(host); }).observe(host, { childList: true, subtree: true });
      scan(host);
    });
  }

  watch();
  document.addEventListener('shopify:section:load', watch);
})();